import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, Input, DatePicker, Select, InputNumber } from 'antd';
import formatAmount from 'indian-currency-formatter';
import moment from 'moment';
import * as Config from '../../../appConfig';

import ActionButtons from './actionButtons';

const { RangePicker } = DatePicker;

const HealthInsurance = ({
  employee: { id: employeeID, healthInsurance } = {},
  onHealthInsuranceUpdate,
  ability,
}) => {
  const [form] = Form.useForm();
  const [isFormReadOnly, setIsFormReadOnly] = useState(
    (healthInsurance && healthInsurance.provider) || !ability.toEditEmployee
  );

  return (
    <Form
      layout="vertical"
      size="large"
      className={`ant-form-custom ${isFormReadOnly ? 'ant-form-readOnly' : ''}`}
      form={form}
      initialValues={{
        id: employeeID,
        provider: healthInsurance && healthInsurance.provider,
        policy_period: healthInsurance &&
          healthInsurance.policy_start_date &&
          healthInsurance.policy_end_date && [
            moment(healthInsurance.policy_start_date),
            moment(healthInsurance.policy_end_date),
          ],
        type: healthInsurance && healthInsurance.type,
        sum_insured: healthInsurance && healthInsurance.sum_insured,
      }}
      onFinish={(values) => {
        setIsFormReadOnly(!isFormReadOnly);
        if (
          (values.provider && values.provider !== '') ||
          (values.type && values.type !== '')
        ) {
          onHealthInsuranceUpdate(values);
        }
      }}
    >
      <Row>
        <Col flex="auto" style={{ textAlign: 'right' }}>
          {ability.toEditEmployee && (
            <ActionButtons
              showEditBtn={isFormReadOnly}
              onEditClick={() => setIsFormReadOnly(!isFormReadOnly)}
              onCancelClick={() => {
                setIsFormReadOnly(!isFormReadOnly);
                form.resetFields();
              }}
            />
          )}
        </Col>
      </Row>
      <Row gutter={128}>
        <Col xs={24} md={6}>
          <Form.Item label="Provider" name="provider">
            <Select placeholder="Please select" disabled={isFormReadOnly}>
              {['STAR', 'UIIC'].map((provider_option) => (
                <Select.Option key={provider_option} value={provider_option}>
                  {provider_option}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={18}>
          <Form.Item label="Policy Period" name="policy_period">
            <RangePicker
              disabled={isFormReadOnly}
              format={Config.DATE_FORMAT_INPUT}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={128}>
        <Col xs={24} md={6}>
          <Form.Item label="Type" name="type">
            <Select placeholder="Please select" disabled={isFormReadOnly}>
              {['INDIVIDUAL', 'FAMILY'].map((type_option) => (
                <Select.Option key={type_option} value={type_option}>
                  {type_option}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={18}>
          <Form.Item label="Sum Insured" name="sum_insured">
            <InputNumber
              // max={}
              formatter={(value) => formatAmount(value)}
              parser={(value) => value.replace(/(,*)/g, '')}
              style={{
                width: '170px',
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>
    </Form>
  );
};

HealthInsurance.defaultProps = {};

HealthInsurance.propTypes = {
  employee: PropTypes.object.isRequired,
  onHealthInsuranceUpdate: PropTypes.func.isRequired,
  ability: PropTypes.object.isRequired,
};

export default HealthInsurance;
